/**
 * The one place the shell's mobile breakpoint is written down (UX-03).
 *
 * `AppShell.tsx` gated its drawer behaviour — focus trap, Escape-to-close,
 * focus restore, `role="dialog"` semantics — on `max-width: 900px`, while
 * `AppShell.module.css` turned the sidebar into an off-canvas drawer at
 * `max-width: 860px`. Between 861 and 900 the two disagreed: the sidebar was
 * still a plain static column on screen, and the code treated it as a modal
 * dialog — trapping a keyboard user inside the navigation of a page whose
 * layout gave them no reason to think they were in one.
 *
 * A media query cannot read a CSS custom property, so this genuinely cannot be
 * one value in one file. What it CAN be is one value plus a test: the literal
 * stays in the stylesheet, and `breakpoints.test.ts` fails if it ever drifts
 * from the constant below.
 *
 * 860 rather than 900 because the STYLESHEET is what the user sees. The code
 * should follow the layout, not the other way round.
 *
 * ── AND SINCE #1466 F-30B THE NUMBER ITSELF IS SHARED ───────────────────────
 * The console's off-canvas sidebar and the shared drawer's collapse are the same
 * viewport boundary, so ADR F-30 decision 7 puts ONE semantic constant in the
 * shared shell API and has each host import it. This file keeps its own NAME —
 * `MOBILE_MAX_PX` is what `AppShell.tsx` reads and what the UX-03 argument above
 * is written about — but it no longer keeps its own VALUE, because two hosts
 * each holding a copy of one boundary is exactly the drift UX-03 was.
 */
import { SHELL_COMPACT_MAX_PX } from '@solum/ui'

export const MOBILE_MAX_PX: number = SHELL_COMPACT_MAX_PX

/** The matchMedia query for "the sidebar is currently a drawer". */
export const MOBILE_QUERY = `(max-width: ${MOBILE_MAX_PX}px)`
